// extracted by mini-css-extract-plugin
export default {"wrapper":"cardRecord_wrapper__JowsY","version":"cardRecord_version__psTOi"};